import axiosInstance from '../functions/axiosInstance';
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const retireSelectedResources = async (searchResults = null, apiToken = null) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    if (!searchResults) {
        console.log("no searchResults");
        return null;
    }
    let selectedResources = searchResults.filter(result => result.selectedToRetire === true);
    if (!selectedResources.length) {
        alert("no resources selected to retire");
        return null;
    }
    let notRetiredList = [];
    for (const result of selectedResources) {
        const foi = result.targetfoi;
        if (foi) {
            console.log("CALLING SERVER with retireresource " + foi);
            await axiosInstance({
                method: 'POST',
                url: fevir_node_server_address,
                timeout: 120000,
                data: {
                    'functionid': 'retireresource',
                    'apiToken': apiToken,
                    'foi': foi,
                },
            }).then((resp) => {
                if (resp?.data) {
                    if (!resp.data.success) {
                        notRetiredList.push(foi);
                        if (resp.data.message) {
                            alert(resp.data.message);
                        }
                    }
                } else {
                    console.log("NO RESPONSE from retireresource call");
                }
            }).catch((error) => { console.log(error); });
        } else {
            alert("Result missing FOI");
        }
    }
    if (notRetiredList.length > 0) {
        alert("The following Resources were not retired: " + notRetiredList.join(", "));
    } else {
        alert("Selected Resources were retired.");
    }
};

export default retireSelectedResources;